var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EchartPractice"},[_c('div',{class:_vm.className,style:({ width: '100%', height: '250px' }),attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }